module.exports = __webpack_public_path__ + "img/guide2_pc.672b1c4f.jpg";